// The classic API already returns its full comment collection. Resolve links
// against that authorized collection, without another request or a global ticker.
export function legacyForumPage(value) {
  return /^[1-9]\d*$/.test(String(value || '')) && Number.isSafeInteger(Number(value)) ? Number(value) : 1;
}

export function legacyThreadLocation(route, comments, pageSize = 10) {
  const query = route.query || {}, hash = /^#comment-([1-9]\d*)$/.exec(route.hash || '');
  const id = query.comment_id === undefined ? hash && hash[1] : String(query.comment_id);
  const pages = Math.max(1, Math.ceil(comments.length / pageSize));
  if (query.comment_id !== undefined || hash) {
    const index = comments.findIndex(comment => String(comment.cid) === id);
    return index < 0 ? { unavailable: true, page: 1, id: null } : { page: Math.floor(index / pageSize) + 1, id };
  }
  if (query.last === 'true' || query.position === 'last') return { page: pages, id: comments.length ? String(comments[comments.length - 1].cid) : 'op' };
  if (route.hash === '#comment-op' || route.hash === '#topic-' + route.params?.nid) return { page: 1, id: 'op' };
  return { page: Math.min(pages, legacyForumPage(query.page)), id: null };
}
export function legacyForumView(value) {
  return ['recent', 'valores', 'search', 'index'].includes(value) ? value : 'recent';
}
